import React from 'react';
import LinkBase, { type TLinkBase } from './LinkBase';

const Link = (props: TLinkBase) => <LinkBase {...props} />;

export default Link;
